<script>

import {ColorSorter} from "../common/mixins/ColorSorter";
import SelectorColorChips from "../common/selector/fragment/SelectorColorChips.vue";

export default {
    components: {SelectorColorChips: SelectorColorChips},
    mixins: [ColorSorter],
    props: {
        accessory: {
            type: Object,
            required: true
        },
    },
    computed: {
        defaultVersion: function () {
            return this.accessory.versions[0];
        }
    },
    methods: {
        showBanner: function () {
            return this.defaultVersion.banner !== null
        },
        getPriceWithoutPromo: function () {
            if (this.defaultVersion.discountedPriceInCents === this.defaultVersion.priceInCents) {
                return null
            }
            return this.defaultVersion.priceInCents
        }
    }
}
</script>

<template>
    <ob1-cards
        is-link
        :link="defaultVersion.productSheetUrl"
        data-oevent-category="selecteur_produit"
        :data-oevent-action="'bloc_' + accessory.name.split(' ').join('_')"
        :data-oevent-label="defaultVersion.productSheetUrl"
    >
        <!--/* Banner */-->
        <ob1-tag v-if="showBanner()" class="banner" :label="defaultVersion.banner.label" />
        <div class="d-flex flex-row pt-1">
            <!--/* img+das+banner */-->
            <div class="img-mobile mt-1 mb-2 mx-1">
                <!--/* Image */-->
                <div class="d-flex img-container">
                    <selector-color-chips :colors="accessory.colors" />
                    <ob1-picture
                        v-if="defaultVersion.mainImage"
                        class="accessoryPicture"
                        :visual="defaultVersion.mainImage"
                    />
                </div>
            </div>
            <div class="infos d-flex align-items-start flex-column">
                <!--/* Titre */-->
                <div class="infos-accessory">
                    <h2 class="no-signature standard py-0 my-0 fw-normal">
                        <strong class="standard">{{ accessory.name }}</strong>
                    </h2>
                    <!--/* rating + la note */-->
                    <ob1-rating
                        v-if="defaultVersion.reviews"
                        :average="defaultVersion.reviews.average"
                        :with-score="true"
                        :rating-results-height="1.010"
                        :font-size="0.875"
                    />
                </div>
                <div v-if="accessory.versions.length > 0" class="infos-price mt-auto">
                    <!--/* Statut */-->
                    <ob1-tag
                        v-if="accessory.status !== null && accessory.status.label !== null"
                        class="mt-1 mt-md-0"
                        type="unavailable"
                        :label="accessory.status.label"
                    />
                    <!--/* Prix */-->
                    <ob1-prix-terminal
                        :multiple-price="accessory.versions.length > 1"
                        :compact-price="true"
                        :total-price-with-promo="defaultVersion.discountedPriceInCents"
                        :total-price-without-promo="getPriceWithoutPromo()"
                        :is-cents-format="true"
                        :payment-info-label="defaultVersion.paymentInfoLabel ? defaultVersion.paymentInfoLabel.label : null"
                    />
                </div>
            </div>
        </div>
        <div class="row infos-advantage px-1">
            <!--/* ODR */-->
            <ob1-message-complementaire
                v-if="defaultVersion.odrMessage"
                class="p-1"
                :icon="'icon-rewards'"
                :is-reduced="true"
                :title="defaultVersion.odrMessage"
                :has-alert-content="false"
            />
            <div v-else class="pb-1" />
        </div>
    </ob1-cards>
</template>

<style lang="scss">
@import 'msh_mixins';
@import 'ob1_common';
@import 'ob1_variables';

.banner {
    position: absolute;
    top: 0;
    left: 0;
}

.img-container {
    position: relative;
}

.img-mobile {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.accessoryPicture img {
    width: px-to-rem(127);
}

</style>
